import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
// export default (props) => (
//   <LiveTemplateDefault
//     location={props.location}
//     lang="en"
//     market="us"
//     callsign="ALTSPRT"
//     title="Watch Altitude Sports Live with Fubo"
//     networkName="Altitude Sports"
//   />
// )

export default (props) => {
  return <RedirectTemplate location={props.location} destination="/tv/" />
}
